import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { Phone, Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import logo from "@/assets/logo-jacky-couverture.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const services = [
    { name: "Couverture", url: "/services/couverture" },
    { name: "Zinguerie", url: "/services/zinguerie" },
    { name: "Peinture Hydrofuge", url: "/services/peinture-hydrofuge" },
    { name: "Façade & Extérieur", url: "/services/facade-exterieur" },
    { name: "Démoussage", url: "/services/demoussage-toiture" },
    { name: "Hydrofuge", url: "/services/hydrofuge-toiture" },
    { name: "Remplacement Toiture", url: "/services/remplacement-toiture" },
    { name: "Rénovation", url: "/services/renovation-toiture" },
    { name: "Tuile & Ardoise", url: "/services/tuile-ardoise" },
    { name: "Pose Velux", url: "/services/pose-velux" },
    { name: "Traitement Charpente", url: "/services/traitement-charpente" },
    { name: "Isolation", url: "/services/isolation-toiture" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/80 backdrop-blur-xl supports-[backdrop-filter]:bg-background/70 shadow-sm">
      <div className="container mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center space-x-2 transition-smooth hover:scale-105">
          <img 
            src={logo} 
            alt="Jacky Couverture" 
            className="h-12 w-auto" 
            width="48" 
            height="48" 
            loading="eager"
            style={{ maxWidth: '48px', maxHeight: '48px', objectFit: 'contain' }}
          />
        </a>

        {/* Desktop Navigation */}
        <NavigationMenu className="hidden md:flex">
          <NavigationMenuList>
            <NavigationMenuItem>
              <a href="/" className="px-5 py-2 text-sm font-semibold transition-smooth hover:text-accent relative after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:h-1 after:w-0 after:bg-accent after:rounded-full after:transition-all hover:after:w-full after:shadow-accent">
                Accueil
              </a>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuTrigger>Services</NavigationMenuTrigger>
              <NavigationMenuContent>
                <div className="grid gap-1 p-4 w-80 grid-cols-2">
                  {services.map((service) => (
                    <a
                      key={service.name}
                      href={service.url}
                      className="block px-3 py-2 text-sm rounded-md transition-smooth hover:bg-muted hover:text-accent relative after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:h-0.5 after:w-0 after:bg-accent after:rounded-full after:transition-all hover:after:w-3/4"
                    >
                      {service.name}
                    </a>
                  ))}
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <a href="/zone-intervention" className="px-5 py-2 text-sm font-semibold transition-smooth hover:text-accent relative after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:h-1 after:w-0 after:bg-accent after:rounded-full after:transition-all hover:after:w-full after:shadow-accent">
                Zone d'Intervention
              </a>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <a href="/contact" className="px-5 py-2 text-sm font-semibold transition-smooth hover:text-accent relative after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:h-1 after:w-0 after:bg-accent after:rounded-full after:transition-all hover:after:w-full after:shadow-accent">
                Contact
              </a>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>

        {/* Phone Button & Mobile Menu */}
        <div className="flex items-center space-x-3">
          <Button variant="default" size="sm" className="hidden sm:flex items-center space-x-2 shadow-primary hover:shadow-accent transition-smooth">
            <Phone className="h-4 w-4" />
            <span className="font-semibold">06.46.70.26.17</span>
          </Button>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="sm" className="md:hidden">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-80">
              <div className="flex flex-col space-y-6 mt-6">
                <a
                  href="/"
                  className="text-lg font-medium transition-smooth hover:text-primary"
                  onClick={() => setIsOpen(false)}
                >
                  Accueil
                </a>
                
                <div>
                  <div className="text-lg font-medium mb-3">Services</div>
                  <div className="grid gap-2 pl-4">
                    {services.map((service) => (
                      <a
                        key={service.name}
                        href={service.url}
                        className="text-sm text-muted-foreground transition-smooth hover:text-primary"
                        onClick={() => setIsOpen(false)}
                      >
                        {service.name}
                      </a>
                    ))}
                  </div>
                </div>
                
                <a
                  href="/zone-intervention"
                  className="text-lg font-medium transition-smooth hover:text-primary"
                  onClick={() => setIsOpen(false)}
                >
                  Zone d'Intervention
                </a>
                
                <a
                  href="/contact"
                  className="text-lg font-medium transition-smooth hover:text-primary"
                  onClick={() => setIsOpen(false)}
                >
                  Contact
                </a>

                <Button className="mt-6 w-full">
                  <Phone className="h-4 w-4 mr-2" />
                  06.46.70.26.17
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;